import {Box} from "@mui/material";
import {SurveyType} from "crqlar-react-common/dist/models/survey/survey.model";
import React from "react";
import {useTranslation} from "react-i18next";
import {ElementChip} from "./base/ElementChip";
import {getSurveyTypeColor} from "./colors";

export const SURVEY_TYPE_LABEL_KEYS: Record<SurveyType, string> = {
    [SurveyType.PRE_STAY]: 'Pre stay',
    [SurveyType.POST_STAY]: 'Post stay',
    [SurveyType.PRE_SERVICE]: 'Pre service',
    [SurveyType.POST_SERVICE]: 'Post service',
    [SurveyType.ANONYMOUS]: 'Anonymous',
};

interface SurveyTypeElementProps {
    type: SurveyType | undefined;
    asPrint?: boolean;
}

export function SurveyTypeElement({type, asPrint = false}: SurveyTypeElementProps) {
    const {t} = useTranslation();

    if (!type) {
        return null;
    }

    const text = t(SURVEY_TYPE_LABEL_KEYS[type] ?? type);

    if (asPrint) {
        return <>{text}</>;
    }

    return (
        <Box sx={{display: "inline-flex", maxWidth: "100%"}}>
            <ElementChip
                text={text}
                startIcon={
                    <Box
                        component="span"
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: getSurveyTypeColor(type),
                            flex: "0 0 auto",
                        }}
                    />
                }
            />
        </Box>
    );
}
